<template>
  <el-container style="height: 600px">
    <el-header>
      <div class="header">
        <div class="headerson">
          <div>
            <el-dialog title="房间记录" :visible.sync="cleanRecordShow">
              <el-timeline :reverse="false">
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :timestamp="activity.createTime"
                >
                  <div style="display: flex">
                    <div>{{ activity.logTypeName }}</div>
                    <div style="font-size: 12px; margin-left: 5px; color: blue">
                      {{ activity.remake }}
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
              <div slot="footer" class="dialog-footer">
                <div>
                  <el-button
                    v-if="currentHomeInfo.isClean == 0"
                    type="primary"
                    @click="saveCleanLog(0)"
                    >需要打扫</el-button
                  >
                  <el-button
                    v-if="currentHomeInfo.isClean == 1"
                    type="primary"
                    @click="saveCleanLog(1)"
                    >完成打扫</el-button
                  >
                </div>
              </div>
            </el-dialog>
          </div>

          <div v-if="orderShow">
            <checkOrderDetail
              :dialogShow="orderShow"
              ref="checkOrder"
              @action="productShowAction()"
              @pushdata="pushdata"
              @modelShowChange="checkOrderShowChange"
            />
          </div>
          

          <div style="margin: 5px; margin-left: 15px" class="type">
            <div class="all"></div>
            <div>空房 {{ sellNum }}</div>
          </div>

          <div style="margin: 5px; margin-left: 15px" class="type">
            <div class="leave"></div>
            <div>今日预离 {{ todayLeaveNum }}</div>
          </div>

          <div style="margin: 5px; margin-left: 15px" class="type">
            <div class="yd"></div>
            <div>今日预抵 {{ todayyyNum }}</div>
          </div>

          <div style="margin: 5px; margin-left: 15px" class="type">
            <div class="gy"></div>
            <div>今日过夜 {{ todakyNum }}</div>
          </div>

          <div style="margin: 5px; margin-left: 15px" class="type">
            <img
              src="../assets/ds.png"
              style="margin-right: 5px; width: 25px; height: 25px"
            />
            <div>需要打扫 {{ cleanNum }}</div>
          </div>

          <div style="margin-left:130px">
            <el-date-picker 
            @change="changeTime"
            v-model="date" type="date" placeholder="选择日期">
          </el-date-picker>
          <el-button style="margin-left:10px" type="" icon="el-icon-search" @click="pushdata">查询</el-button>
          <el-button style="margin-left:10px" type="" icon="el-icon-refresh-left" @click="reset">刷新</el-button>
          </div>

         
        </div>
      </div>
    </el-header>
    <el-container>
      <el-main>
        <div
          class="detail"
          style="display: flex; justify-content: center; align-items: center"
          v-if="isshowInfo"
        >
          <img src="../assets/ysms.png" style="width: 165px; height: 165px" />
        </div>
        <div class="detail" v-if="!isshowInfo">
          <div>
            <!-- <div style="width: 100%; text-align: center" v-if="load2">
              加载中...
            </div> -->
            <el-skeleton animated v-show="load2" />
            <div v-for="item in home" :key="item.title" class="content">
              
              <div :class="item.class" @click="homeInfo(item)">
                <div>
                  <div
                    style="
                      display: flex;
                      margin: 10px;
                      justify-content: space-between;
                    "
                  >
                    <div style="display: flex" v-on:click.stop="xgfj(item)">
                      <div>{{ item.homeTypeName }}</div>
                      <img
                        src="../assets/bjfj2.png"
                        style="width: 25px; height: 25px"
                      />
                    </div>

                    <div style="display: flex">
                      <img
                        src="../assets/ds.png"
                        v-if="item.isClean == 1"
                        style="width: 30px; height: 30px"
                      />
                    </div>
                  </div>
                  <div class="data">
                    <div
                      style="
                        font-size: 25px;
                        display: flex;
                        justify-content: center;
                      "
                    >
                      <div>{{ item.homeNum }}</div>
                    </div>
                    <div
                      style="
                        display: flex;
                        font-size: 26px;
                        justify-content: center;
                      "
                    >
                      <div
                        style="height: 30px; font-size: 18px"
                        :v-show="item.checkPersonName"
                      >
                        {{ item.checkPersonName }}
                      </div>
                      <img
                        src="../assets/vip.png"
                        v-if="item.isVip == 1"
                        style="width: 30px; height: 25px"
                      />
                    </div>
                  </div>

                  <div class="status">
                    <div
                      style="margin-left: 5px"
                      v-if="!item.checkPersonName"
                      class="kong"
                    >
                      空
                    </div>
                    <div
                      style="margin-left: 5px"
                      v-if="item.checkPersonName"
                      class="jrtf"
                    >
                      {{ getDiffDay(item.timeEnd) }}离
                    </div>
                    <div
                      style="margin-left: 5px"
                      v-if="item.isSchedule == 1 && item.isArrive==0"
                      class="yyd"
                    >
                      定
                    </div>
                    <div
                      style="margin-left: 5px"
                      v-if="item.outTime == 1"
                      class="yyd"
                    >
                      超
                    </div>
                    <div
                      style="margin-left: 5px"
                      v-if="item.outMoney == 1"
                      class="yyd"
                    >
                      欠
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import store from "@/store/";
import checkOrderDetail from "@/components/checkOrderDetail";
export default {
  components: {
    checkOrderDetail,
  },
  data() {
    return {
      date: "",
      workShow: true,
      currentHomeInfo: "",
      reverse: true,
      activities: [
      ],
      load2: false,
      logLoadding: false,
      ischeck: false,
      orderShow: false,
      isshowInfo: false,
      cleanRecordShow: false,
      req: {
        parma: "",
        time: "",
        pageIndex: 0,
        pageCount: 3,
        query: {
          sysUserId: 0,
        },
      },
      data: [],
      home: [],
      todakyNum: 0,
      todayyyNum: 0,
      todayLeaveNum: 0,
      sellNum: 0,
      cleanNum: 0,
    };
  },
  computed: {
    noMore() {
      return this.count >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  mounted() {
    this.req.query.sysUserId = this.$store.state.user.user.id;
    console.log("当前时间：" + this.getNowFormatDate());
    this.date= this.getNowFormatDate();
    this.req.time = this.getNowFormatDate();
    this.pushdata();
  },
  watch: {
    parma: {
      handler(newName, oldName) {
        // this.pushdata();
      },
      // 如果设置了false，那么在页面第一次渲染以后不会触发侦听器
      immediate: true,
    },
  },
  methods: {
    formatDate(d){
        var date = new Date(d);
        var YY = date.getFullYear() + "-";
        var MM =
            (date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1) + "-";
        var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hh =
            (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
        var mm =
            (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
            ":";
        var ss =
            date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        return YY + MM + DD + " " + hh + mm + ss;
    },
    changeTime(){
      console.log(this.date)
      this.req.time=this.formatDate(this.date).split(" ")[0].concat(" 23:59:59")
      this.date=this.formatDate(this.date).split(" ")[0].concat(" 23:59:59")
      console.log( this.req.time)
    },
    changeTime2(){
      console.log(this.date)
      this.req.time=this.formatDate(this.date).split(" ")[0].concat(" 23:59:59")
      this.date=this.formatDate(this.date).split(" ")[0].concat(" 23:59:59")
      console.log( this.req.time)
    },
    getTime(){
      return this.req.time
    },
    checkOrderShowChange(visible) {
      this.orderShow = visible;
    },
    reset(){
      this.req.time = this.getNowFormatDate();
      this.date = this.getNowFormatDate();
      this.pushdata();
    },
    showLog() {
      var that = this;
      that.$axios
        .get("/api2/business/getHomeLogs/" + this.currentHomeInfo.id, {})
        .then(function (response) {
          that.activities = response.data.data;
        });
    },

    saveCleanLog(a) {
      let parma = {
        homeId: this.currentHomeInfo.id,
        remake: "",
        logTypeName: a == 0 ? "需要打扫" : "完成打扫",
        logType: a,
      };
      var that = this;
      that.$axios
        .post("/api2/business/saveHomeLog", parma)
        .then(function (response) {
          that.$message({
            type: "success",
            message: "操作成功",
          });
          that.pushdata();
          that.cleanRecordShow = false;
        });
    },

    xgfj(item) {
      console.log("修改房间");
      this.currentHomeInfo = item;
      this.cleanRecordShow = true;
      this.showLog();
    },

    dealData(item) {
      if (item.timeEnd) {
        console.log("当前时间：" + new Date().toDateString());
        console.log("当前时间2：" + new Date(this.date).toDateString());
        var endtime = new Date(item.timeEnd).getTime();
        var startTime = new Date(item.timeStart).getTime();
        console.log("退房时间" + new Date(endtime).toDateString());
        var todayLeave =
          new Date(this.date).toDateString() === new Date(endtime).toDateString();
        var todayyy =
          new Date(this.date).toDateString() === new Date(startTime).toDateString();

        //判断今天离开和不离开
        console.log("是否今日离店" + todayLeave);
        if (todayLeave) {
          this.todayLeaveNum++; //今日离开
          this.$set(item, "class", "itemleave");
          this.$set(item, "isLeave", true);
          //超过退房时间
          var now = new Date().getTime();
          if (item.timeEnd) {
            var quit = item.timeEnd.split(" ")[0] + " " + item.homeQuit + ":00";
            console.log("退房时间1：" + quit);
            var quitTime = new Date(quit).getTime();
            console.log("退房时间时间戳：" + quitTime);
            if (now > quitTime) {
              this.$set(item, "outTime", 1);
            }
          }
        } else {
          this.todakyNum++; //今日过夜
          this.$set(item, "class", "itemgy");
        }
      }

      if (todayyy && item.isSchedule == 1 && item.isArrive==0) {
        this.$set(item, "class", "itemyd");
        this.todayyyNum++; //今日预约
      }
      if (!item.checkPersonName) {
        this.$set(item, "class", "itemsell");
        this.sellNum++; //在售数量
      }
      if (item.isClean == 1) {
        this.cleanNum++; //打扫
      }
      //欠费
      var day = item.continued + item.startDays;
      console.log("检查欠费" + item.homePriceCost + item.homePrice + day);
      if (
        item.homePriceCost <
        item.homePrice * (item.continued + item.startDays)
      ) {
        console.log(
          item.homePriceCost <
            item.homePrice * (item.continued + item.startDays)
        );
        this.$set(item, "outMoney", 1);
      }
    },

    // 获取当前时间 格式为“yyyy-MM-dd HH:MM:SS”
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
    homeInfo(item) {
      this.orderShow = true;
      setTimeout(() => {
        var newitem={
          ...item,
          time:this.date
        }
        this.$refs["checkOrder"].init(newitem); //用$refs赋值调用子组件的init方法
      }, 500);
    },
    setZero() {
      this.todakyNum = 0;
      this.todayyyNum = 0;
      this.todayLeaveNum = 0;
      this.sellNum = 0;
      this.cleanNum = 0;
    },

    getDiffDay(date_1) {
      if (!date_1) {
        return;
      }
      // 计算两个日期之间的差值
      let totalDays, diffDate;
      let myDate_1 = Date.parse(date_1);
      let myDate_2 = new Date();
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值

      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
      // console.log(totalDays)
      console.log(totalDays + "日离开");

      return totalDays >= 1 ? totalDays + "日" : ""; // 相差的天数
    },

    pushdata() {
      this.home=[]
      this.setZero();
      var that = this;
      that.load2 = true;
      that.$axios
        .post("/api2/business/getCheckOrder", this.req)
        .then(function (response) {
          that.home = response.data.data;
          that.home.forEach((element) => {
            that.dealData(element);
          });
          console.log(that.home);
          that.load2 = false;
        });
    },
  },
};
</script >
<style   scoped>
.status {
  width: 97%;
  height: 30px;
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  text-align: left;
}

.item:hover {
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
}

.data {
  font-size: 30px;
  font-weight: 600;
  text-align: center;
}

.content {
  display: flex;
  float: left;
}

.item {
  margin-left: 30px;
  width: 120px;
  height: 80px;
  background-color: #cbcbcb;
}

.like {
  cursor: pointer;
  font-size: 25px;
  display: inline-block;
}

.icon {
  width: 20px;
  height: 20px;
}

.type {
  display: flex;
}
.yd {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background-color: #e0c85e;
}
.gy {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background-color: #676461;
}
.leave {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background-color: #6f66a7;
}
.all {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  background-color: #cbcbcb;
}
.headerson {
  display: flex;
  align-items: center;
  padding: 8px;
}
input {
  width: 270px;
  font-size: 17px;
  height: 37px;
  background-color: rgb(219, 229, 238);
  border-radius: 28px;
  border: none;
  outline: none;
  text-indent: 3em;
  background: url(../assets/ss.png) no-repeat 5%;
  background-size: 25px 25px;
}
.header {
  background-color: rgb(246, 248, 248);
  width: 100%;
  height: 50px;
}

.active {
  width: 280px;
  height: 180px;
  border: 1px dashed #3e6db8;
  background-color: rgb(252, 254, 254);
  margin-bottom: 10px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.24);
}

.item {
  margin-right: 10px;
}
.itemleave {
  width: 240px;
  height: 140px;
  background-color: #6f66a7;
  margin-bottom: 10px;
  margin-right: 10px;
  color: white;
}
.itemyd {
  width: 240px;
  height: 140px;
  background-color: #e0c85e;
  margin-bottom: 10px;
  margin-right: 10px;
  color: white;
}
.itemgy {
  width: 240px;
  height: 140px;
  background-color: #676461;
  margin-right: 10px;
  margin-bottom: 10px;
  color: white;
}
.itemsell {
  position: relative;
  width: 240px;
  height: 140px;
  background-color: #cbcbcb;
  margin-right: 10px;
  margin-bottom: 10px;
  color: white;
}
.yyd {
  height: 25px;
  width: 25px;
  background-color: #3e6db8;
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
}
.kong {
  height: 25px;
  width: 25px;
  background-color: #3e6db8;
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
}
.jrtf {
  height: 25px;
  min-width: 25px;
  background-color: rgb(161, 143, 8);
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
}

.el-container {
  height: 100%;
}

.info {
  font-size: 25px;
}
table {
  border: 2px solid #cbcbcb;
}
</style>
